import { RankedTester,and,isControl,optionIs,rankWith } from '@jsonforms/core';
const tester:RankedTester=rankWith(20,and(isControl,optionIs('EventCertificateManagement',true)));
export default tester;
